import { createStore, applyMiddleware, compose } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import thunk from 'redux-thunk'
// import createHistory from 'history/createBrowserHistory'
import { createBrowserHistory } from 'history'
import rootReducer from './modules'
import { loadingBarMiddleware } from 'react-redux-loading-bar'

export const history = createBrowserHistory()

const initialState = {}
const enhancers = []
const middleware = [thunk, routerMiddleware(history)]

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)

export default createStore(
  connectRouter(history)(
    rootReducer,
    // promise middleware
    applyMiddleware(loadingBarMiddleware({
      promiseTypeSuffixes: ['GET', 'POST', 'PUT'],
    }))
    ),
  initialState,
  composedEnhancers
)
